module.exports = __webpack_public_path__ + "media/images/operation_jobs/icon_shoes-633717fd3e348ad722dd231712d48d4f.png";